/*
  rs-namecard.js - The Revenge Store
  Live word-art "name card" preview + $10 add-on for the product page.
  Engine is the LOCKED Card Art Studio layout (edge-anchored, mixed fonts,
  Sweet/Snarky earthy palettes). One card per page.

  The section liquid calls:  RSNameCard.init(sectionEl, { vibe, variantId, propertyKey })
*/
(function(){
  'use strict';

  // ---------- defaults ----------
  var SWEET_WORDS  = ['Strength','Healing','Empowering','Thrive','Courage','Nourish','Renewal','Recover','Bloom','Flourish','Balance','Vitality','Uplift','Inspire','Restore','Fortify','Ascend','Cultivate','Whole','Refresh'];
  var SNARKY_WORDS = ['Ugh','Eyeroll','Classic','And?','Really?','Unamused','Whatever','Snark','Unimpressed','Seriously?','Next','Nah','Don\u2019t','Eww','Shrug','Nope','Done'];
  var VIBES = { sweet:SWEET_WORDS, snarky:SNARKY_WORDS };
  var DEFAULT_WORDS = SWEET_WORDS;

  var PALETTES = {
    festive:{ label:'Festive', colors:['#C75B27','#6A4C93','#B98A1E','#2E9B8E','#2C3E50','#5B85C0','#4A9B6E','#c8202c'] },
    sweetwarm:{ label:'Sweet - warm & earnest', colors:['#C2683E','#C19858','#7E9472','#B97E72','#9A8468','#B98A1E','#8A6F4E','#5C4F40'] },
    snarkycool:{ label:'Snarky - cool & dry', colors:['#33363A','#1F3350','#3A6E69','#56606A','#15327a','#33363A','#3A6E69','#2C4A47','#46505A','#1F3350','#33363A','#3A6E69','#56606A','#c8202c','#8a131c'] },
    warm:{ label:'Warm', colors:['#C75B27','#B98A1E','#9A3B2A','#D08C2C','#6A4C93','#8a4a1e','#b0473f','#2C3E50'] },
    cool:{ label:'Cool', colors:['#1d4fd8','#2E9B8E','#15327a','#5B85C0','#4A9B6E','#6A4C93','#2C3E50','#3a8f9b'] },
    sweet:{ label:'Sweet (blue)', colors:['#1d4fd8','#15327a','#1A1008','#5C4F40','#3A6BB0','#274a8f'] },
    snarky:{ label:'Snarky (red)', colors:['#c8202c','#8a131c','#1A1008','#5C4F40','#b0473f','#7a1620'] }
  };

  var FONTS = {
    mixed:{ label:'* Mixed (artful)', mix:true },
    bitter:{ label:'Bitter - sturdy serif', stack:"'Bitter', Georgia, serif", weight:800 },
    playfair:{ label:'Playfair - high contrast', stack:"'Playfair Display', Georgia, serif", weight:800 },
    dmserif:{ label:'DM Serif - classic display', stack:"'DM Serif Display', Georgia, serif", weight:400 },
    ptserif:{ label:'PT Serif - classic book serif', stack:"'PT Serif', Georgia, serif", weight:400 },
    sourceserif:{ label:'Source Serif - clean transitional', stack:"'Source Serif 4', Georgia, serif", weight:600 },
    notoserif:{ label:'Noto Serif - even & readable', stack:"'Noto Serif', Georgia, serif", weight:400 },
    instrument:{ label:'Instrument - elegant', stack:"'Instrument Serif', Georgia, serif", weight:400 },
    cormorant:{ label:'Cormorant - refined', stack:"'Cormorant Garamond', Georgia, serif", weight:700 },
    marcellus:{ label:'Marcellus - roman caps', stack:"'Marcellus', Georgia, serif", weight:400 },
    yeseva:{ label:'Yeseva - soft display', stack:"'Yeseva One', Georgia, serif", weight:400 },
    rozha:{ label:'Rozha - dramatic', stack:"'Rozha One', Georgia, serif", weight:400 },
    abril:{ label:'Abril Fatface - bold', stack:"'Abril Fatface', Georgia, serif", weight:400 },
    zilla:{ label:'Zilla - slab', stack:"'Zilla Slab', Georgia, serif", weight:700 },
    arvo:{ label:'Arvo - chunky slab', stack:"'Arvo', Georgia, serif", weight:700 },
    alfa:{ label:'Alfa - heavy slab', stack:"'Alfa Slab One', Georgia, serif", weight:400 },
    oswald:{ label:'Oswald - tall sans', stack:"'Oswald', sans-serif", weight:600 },
    anton:{ label:'Anton - condensed', stack:"'Anton', sans-serif", weight:400 },
    archivo:{ label:'Archivo Black - bold sans', stack:"'Archivo Black', sans-serif", weight:400 },
    caveat:{ label:'Caveat - handwritten', stack:"'Caveat', cursive", weight:700 },
    pacifico:{ label:'Pacifico - script', stack:"'Pacifico', cursive", weight:400 },
    lobster:{ label:'Lobster - script', stack:"'Lobster', cursive", weight:400 }
  };
  // fonts blended together when "Mixed" is chosen (serif/slab/display that play nicely)
  var MIX_FONTS = ['bitter','playfair','dmserif','zilla','arvo','yeseva','rozha','marcellus','oswald','abril'];

  var BG = { cream:'#FAF7F2', white:'#FFFFFF', transparent:null };

  var EXPORT = { square:{w:2400,h:2400}, portrait:{w:1800,h:2520}, landscape:{w:2520,h:1800} };
  var LAYOUTDIM = { square:{w:1400,h:1400}, portrait:{w:1400,h:1960}, landscape:{w:1960,h:1400} };

  // ---------- rng ----------
  function mulberry32(a){return function(){a|=0;a=a+0x6D2B79F5|0;var t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296;};}

  var measureCtx = document.createElement('canvas').getContext('2d');

  function buildEntries(rng){
    var colors = PALETTES[state.pal].colors;
    var name = state.name.trim() || 'Their Name';
    var words = state.words.length ? state.words : DEFAULT_WORDS;
    var entries = [];
    function pickFont(){ return state.font==='mixed' ? MIX_FONTS[Math.floor(rng()*MIX_FONTS.length)] : state.font; }
    // name: ONE dominant hero, then a scattered tail of smaller copies (no cluster of big names)
    var nameSizes = [1.00, .38,.31,.26,.22,.19,.165,.145,.13,.12,.11];
    nameSizes.forEach(function(s,i){ entries.push({text:name, scale:s, color:colors[i%colors.length], font:pickFont()}); });
    // each word: a hero copy (first dozen) + a long, dense gradient tail so every gap fills
    words.forEach(function(w, idx){
      var sizes = [];
      if(idx < 12) sizes.push(0.66 - idx*0.022);
      sizes = sizes.concat([0.34,0.30,0.27,0.24,0.215,0.195,0.18,0.165,0.15,0.14,0.13,0.12,0.11,0.10]);
      sizes.forEach(function(s){
        if(s < 0.13 && rng() < 0.28) return;   // light thinning of the very smallest only
        entries.push({text:w, scale:s, color:colors[Math.floor(rng()*colors.length)], font:pickFont()});
      });
    });
    entries.sort(function(a,b){return b.scale-a.scale;});
    return entries;
  }

  function aabb(a,b){ return !(a.x+a.w<b.x||a.x>b.x+b.w||a.y+a.h<b.y||a.y>b.y+b.h); }

  // rotation by "flow" - calm = all horizontal (matches the WordArt reference)
  function pickRot(rng, frac){
    if(state.flow==='calm') return 0;
    if(frac > 0.045) return 0;             // larger words always horizontal
    var r = rng();
    if(state.flow==='mixed'){
      if(r < 0.84) return 0;
      if(r < 0.93) return Math.PI/2;
      return -Math.PI/2;
    }
    if(r < 0.60) return 0;
    if(r < 0.80) return Math.PI/2;
    if(r < 0.92) return -Math.PI/2;
    return (rng()<0.5?1:-1)*Math.PI/14;
  }
  function curveChance(){ return state.flow==='calm' ? 0 : (state.flow==='mixed' ? 0.06 : 0.14); }

  // ---- curved-word geometry (text following a circular arc) ----
  // returns glyph placements in LOCAL coords (circle centre at origin) + local AABB
  function curvedGeom(text, fontKey, fontPx, up){
    var fnt = FONTS[fontKey];
    measureCtx.font = fnt.weight + ' ' + fontPx + 'px ' + fnt.stack;
    var chars = text.split('');
    var widths = chars.map(function(c){ return measureCtx.measureText(c).width; });
    var tw = widths.reduce(function(a,b){return a+b;}, 0);
    var gh = fontPx*0.92;                  // glyph block height (approx)
    var phi = 1.25;                        // total arc angle (radians) -> the amount of curve
    var radius = tw / phi;
    var glyphs = [], acc = 0;
    var minX=1e9,maxX=-1e9,minY=1e9,maxY=-1e9;
    for(var i=0;i<chars.length;i++){
      var wmid = acc + widths[i]/2; acc += widths[i];
      var theta = (wmid - tw/2)/radius;    // angle from centre, left = negative
      var gx, gy, rot;
      if(up){ gx = radius*Math.sin(theta); gy = -radius*Math.cos(theta); rot = theta; }      // arch  and 
      else  { gx = radius*Math.sin(theta); gy =  radius*Math.cos(theta); rot = -theta; }      // smile  or 
      glyphs.push({ch:chars[i], gx:gx, gy:gy, rot:rot});
      var hw=widths[i]/2, hh=gh/2, cs=Math.cos(rot), sn=Math.sin(rot);
      for(var k=0;k<4;k++){
        var sx=(k&1?hw:-hw), sy=(k&2?hh:-hh);
        var rx=gx+sx*cs - sy*sn, ry=gy+sx*sn + sy*cs;
        if(rx<minX)minX=rx; if(rx>maxX)maxX=rx; if(ry<minY)minY=ry; if(ry>maxY)maxY=ry;
      }
    }
    return {glyphs:glyphs, localCx:(minX+maxX)/2, localCy:(minY+maxY)/2, bw:maxX-minX, bh:maxY-minY};
  }

  // ---- pixel-mask word cloud: pack words by their real letter shapes (WordArt-style) ----
  function computeLayout(){
    var dim = LAYOUTDIM[state.aspect];
    var Wl = dim.w, Hl = dim.h;
    var rng = mulberry32((state.seed*2654435761)>>>0);
    var colors = PALETTES[state.pal].colors;
    var name = state.name.trim() || 'Their Name';
    var words = state.words.length ? state.words : DEFAULT_WORDS;
    function pickFont(){ return state.font==='mixed' ? MIX_FONTS[Math.floor(rng()*MIX_FONTS.length)] : state.font; }

    var rcan = document.createElement('canvas');
    var rctx = rcan.getContext('2d', { willReadFrequently:true });

    var cell = 4;
    var gw = Math.ceil(Wl/cell), gh = Math.ceil(Hl/cell);
    var occ = new Uint8Array(gw*gh);
    var items = [];
    var cx = Wl/2, cy = Hl/2, squashY = Hl/Wl;

    // density presets: count multiplier, fill-sweep step, fill sizes, padding cells
    var DENS = {
      airy:     { cmul:0.60, fstep:0.062, fill:[0.024,0.020,0.0165,0.0135],         pad:3 },
      balanced: { cmul:1.00, fstep:0.045, fill:[0.024,0.020,0.0165,0.0135,0.0112],  pad:2 },
      packed:   { cmul:1.55, fstep:0.030, fill:[0.022,0.018,0.015,0.0125,0.0105,0.0088], pad:1 }
    };
    var dc = DENS[state.density] || DENS.balanced;
    var padCells = dc.pad;

    // try to place one word; spiral out from (ax,ay). Returns true if placed.
    function placeWord(text, fs, frot, color, fontKey, ax, ay, maxSteps, stepScale){
      var fnt = FONTS[fontKey];
      measureCtx.font = fnt.weight+' '+fs+'px '+fnt.stack;
      var m = measureCtx.measureText(text);
      var tw = Math.max(1, Math.ceil(m.width));
      var asc = Math.ceil(m.actualBoundingBoxAscent || fs*0.80);
      var desc = Math.ceil(m.actualBoundingBoxDescent || fs*0.20);
      var th = asc + desc, marg = 2;
      var cosR = Math.abs(Math.cos(frot)), sinR = Math.abs(Math.sin(frot));
      var rw = Math.ceil((tw+marg*2)*cosR + (th+marg*2)*sinR);
      var rh = Math.ceil((tw+marg*2)*sinR + (th+marg*2)*cosR);
      rcan.width = rw; rcan.height = rh;
      rctx.clearRect(0,0,rw,rh);
      rctx.save();
      rctx.translate(rw/2, rh/2);
      if(frot) rctx.rotate(frot);
      rctx.font = fnt.weight+' '+fs+'px '+fnt.stack;
      rctx.textAlign='center'; rctx.textBaseline='alphabetic';
      rctx.fillStyle='#000';
      rctx.fillText(text, 0, (asc-desc)/2);
      rctx.restore();

      var data = rctx.getImageData(0,0,rw,rh).data;
      var lcw = Math.ceil(rw/cell), lch = Math.ceil(rh/cell);
      var local = new Uint8Array(lcw*lch);
      for(var py=0; py<rh; py++){
        var rowo = py*rw, lcy = (py/cell)|0;
        for(var px=0; px<rw; px++){
          if(data[(rowo+px)*4+3] > 50){ local[lcy*lcw + ((px/cell)|0)] = 1; }
        }
      }
      var ink = [];
      for(var ly=0; ly<lch; ly++){ var lo=ly*lcw; for(var lx=0; lx<lcw; lx++){ if(local[lo+lx]) ink.push(lx,ly); } }
      if(!ink.length) return false;

      var t=0;
      for(var s=0; s<maxSteps; s++){
        t += 0.11;
        var rr = Wl*stepScale*t;
        var ang = t*0.6;
        var cxp = ax + rr*Math.cos(ang);
        var cyp = ay + rr*Math.sin(ang)*squashY;
        var bcx = Math.round((cxp - rw/2)/cell);
        var bcy = Math.round((cyp - rh/2)/cell);
        if(bcx<0 || bcy<0 || bcx+lcw>gw || bcy+lch>gh) continue;
        var hit=false;
        for(var c=0;c<ink.length;c+=2){ if(occ[(bcy+ink[c+1])*gw + (bcx+ink[c])]){ hit=true; break; } }
        if(hit) continue;
        for(var c2=0;c2<ink.length;c2+=2){
          var gx=bcx+ink[c2], gy=bcy+ink[c2+1];
          occ[gy*gw+gx]=1;
          if(padCells>=1 && gx+1<gw){ occ[gy*gw+gx+1]=1; if(padCells>=2 && gx+2<gw) occ[gy*gw+gx+2]=1; }
          if(padCells>=1 && gy+1<gh){ occ[(gy+1)*gw+gx]=1; if(padCells>=2 && gy+2<gh) occ[(gy+2)*gw+gx]=1; }
          if(padCells>=3){ if(gx+3<gw) occ[gy*gw+gx+3]=1; if(gy+3<gh) occ[(gy+3)*gw+gx]=1; }
        }
        items.push({text:text, font:fontKey, fontPx:fs, color:color, cx:cxp, cy:cyp, rot:frot, voff:(asc-desc)/2});
        return true;
      }
      return false;
    }

    // PASS 1 - distribute words across the WHOLE rectangle so big words abut the edges (WordArt look)
    var tiers = [
      [0.112,1],[0.094,1],[0.079,2],[0.067,2],[0.057,3],[0.050,3],[0.044,4],[0.039,5],
      [0.0345,6],[0.0305,7],[0.027,8],[0.0238,10],[0.0210,11],[0.0185,13],[0.0163,14],
      [0.0144,16],[0.0128,18],[0.0113,20],[0.0100,23],[0.0089,26],[0.0079,30]
    ];
    // flatten tiers into an ordered plan (big -> small)
    var plan = [], wi = Math.floor(rng()*words.length), first = true;
    tiers.forEach(function(tr){
      var frac = tr[0], n = Math.max(1, Math.round(tr[1]*dc.cmul));
      for(var k=0;k<n;k++){
        var useName = first || (rng() < 0.18); first = false;
        plan.push({ text: useName ? name : words[wi++ % words.length], frac: frac });
      }
    });
    // spread anchors for the big words: an edge-spanning grid (corners, edges, centre), shuffled
    var GCOLS = 4, GROWS = 3, anchors = [];
    for(var gr=0; gr<GROWS; gr++) for(var gc=0; gc<GCOLS; gc++){
      anchors.push({ ax:(gc/(GCOLS-1))*Wl, ay:(gr/(GROWS-1))*Hl });
    }
    for(var a=anchors.length-1;a>0;a--){ var bb=Math.floor(rng()*(a+1)); var tm=anchors[a]; anchors[a]=anchors[bb]; anchors[bb]=tm; }
    var NBIG = Math.min(anchors.length, plan.length);
    for(var p=0; p<plan.length; p++){
      var it = plan[p];
      var fs = Math.max(7, it.frac*Wl);
      var ax, ay, steps;
      if(p < NBIG){                                   // giants: anchored to edges/corners/centre
        ax = anchors[p].ax + (rng()-0.5)*Wl*0.10;
        ay = anchors[p].ay + (rng()-0.5)*Hl*0.10;
        steps = 3000;
      } else {                                        // everything else: uniform across the rectangle
        ax = rng()*Wl; ay = rng()*Hl;
        steps = 1500;
      }
      placeWord(it.text, fs, pickRot(rng,it.frac), colors[Math.floor(rng()*colors.length)], pickFont(), ax, ay, steps, 0.0026);
    }

    // PASS 2 - sweep the WHOLE rectangle and tuck small words into the leftover corners & edges
    var fillFracs = dc.fill;
    var fstep = Wl*dc.fstep, fwi = Math.floor(rng()*words.length);
    for(var fy=fstep*0.5; fy<Hl; fy+=fstep){
      for(var fx=fstep*0.5; fx<Wl; fx+=fstep){
        var qcx=(fx/cell)|0, qcy=(fy/cell)|0;
        if(qcx<gw && qcy<gh && occ[qcy*gw+qcx]) continue;   // already covered here
        for(var fi=0; fi<fillFracs.length; fi++){
          var ffrac = fillFracs[fi];
          var ftext = (rng()<0.15) ? name : words[fwi++ % words.length];
          if(placeWord(ftext, Math.max(6,ffrac*Wl), pickRot(rng,ffrac),
                       colors[Math.floor(rng()*colors.length)], pickFont(),
                       fx + (rng()-0.5)*fstep*0.5, fy + (rng()-0.5)*fstep*0.5, 360, 0.0022)) break;
        }
      }
    }
    state.layout = {wl:Wl, hl:Hl, items:items};
  }

  function draw(ctx, targetW, targetH){
    var L = state.layout;
    var scale = targetW / L.wl;
    ctx.clearRect(0,0,targetW,targetH);
    if(!(state.bg==='transparent')){
      ctx.fillStyle = BG[state.bg]; ctx.fillRect(0,0,targetW,targetH);
    }
    ctx.textAlign='center'; ctx.textBaseline='alphabetic';
    for(var i=0;i<L.items.length;i++){
      var it = L.items[i];
      var fnt = FONTS[it.font];
      ctx.fillStyle = it.color;
      ctx.save();
      ctx.translate(it.cx*scale, it.cy*scale);
      if(it.rot) ctx.rotate(it.rot);
      ctx.font = fnt.weight + ' ' + (it.fontPx*scale) + 'px ' + fnt.stack;
      ctx.fillText(it.text, 0, it.voff*scale);
      ctx.restore();
    }
  }




  // ================= per-page state + wiring =================
  var state = {
    name:'', words:VIBES.sweet.slice(), vibe:'sweet',
    pal:'sweetwarm', aspect:'landscape', font:'ptserif', bg:'cream',
    flow:'calm', density:'balanced', seed:7, layout:null
  };

  var els = {};   // cached DOM refs for the one section on the page

  function renderPreview(){
    var canvas = els.canvas; if(!canvas) return;
    var ctx = canvas.getContext('2d');
    var dim = LAYOUTDIM[state.aspect];
    var rect = canvas.parentNode.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cssW = Math.max(320, rect.width), cssH = cssW * (dim.h / dim.w);
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    draw(ctx, canvas.width, canvas.height);
  }
  function recompute(){ computeLayout(); renderPreview(); }

  function setVibe(vibe){
    state.vibe = vibe;
    state.words = (VIBES[vibe] || VIBES.sweet).slice();
    state.pal = (vibe === 'snarky') ? 'snarkycool' : 'sweetwarm';
  }

  function money(cents){
    try { return '$' + (cents/100).toFixed(2); } catch(e){ return ''; }
  }

  function addToCart(cfg){
    var name = (els.name && els.name.value || '').trim();
    if(!name){ if(els.name) els.name.focus(); return; }
    var btn = els.add;
    // Demo mode: no variant configured yet - don't hit the cart, just confirm visually.
    if(!cfg.variantId){
      toast('Demo only - add the variant ID in the theme settings to charge ' + money(cfg.priceCents) + '.');
      return;
    }
    if(btn){ btn.disabled = true; btn.classList.add('is-loading'); }
    var props = {};
    props[cfg.propertyKey || 'Their name'] = name;
    props['Vibe'] = state.vibe === 'snarky' ? 'Snarky' : 'Sweet';
    fetch('/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ items:[{ id: Number(cfg.variantId), quantity:1, properties: props }] })
    }).then(function(r){
      if(!r.ok) throw new Error('cart add failed ' + r.status);
      return r.json();
    }).then(function(){
      window.location.href = '/cart';
    }).catch(function(err){
      if(btn){ btn.disabled = false; btn.classList.remove('is-loading'); }
      toast('Sorry - could not add to cart. Please try again.');
      if(window.console) console.warn('[rs-namecard]', err);
    });
  }

  var _toastTimer = null;
  function toast(msg){
    var t = els.toast; if(!t) return;
    t.textContent = msg; t.classList.add('show');
    clearTimeout(_toastTimer);
    _toastTimer = setTimeout(function(){ t.classList.remove('show'); }, 3200);
  }

  function chooseOption(isUpgrade){
    if(els.upBody) els.upBody.classList.toggle('nc-hidden', !isUpgrade);
    if(els.freeBody) els.freeBody.classList.toggle('nc-hidden', isUpgrade);
    if(isUpgrade) renderPreview();
  }

  function init(root, cfg){
    if(!root) return;
    cfg = cfg || {};
    els.root     = root;
    els.canvas   = root.querySelector('[data-nc-canvas]');
    els.name     = root.querySelector('[data-nc-name]');
    els.reshuffle= root.querySelector('[data-nc-reshuffle]');
    els.add      = root.querySelector('[data-nc-add]');
    els.freeBody = root.querySelector('[data-nc-free]');
    els.upBody   = root.querySelector('[data-nc-upgrade]');
    els.toast    = root.querySelector('[data-nc-toast]');
    els.charNow  = root.querySelector('[data-nc-charcount]');
    els.freemsg  = root.querySelector('[data-nc-message]');

    setVibe(cfg.vibe || 'sweet');
    if(els.name && els.name.value) state.name = els.name.value.trim();

    if(els.name) els.name.addEventListener('input', function(){
      state.name = els.name.value; recompute();
    });
    if(els.reshuffle) els.reshuffle.addEventListener('click', function(){
      state.seed = (state.seed * 1103515245 + 12345) >>> 0 || 1; recompute();
    });
    if(els.add) els.add.addEventListener('click', function(){ addToCart(cfg); });

    root.querySelectorAll('[data-nc-opt]').forEach(function(o){
      o.addEventListener('click', function(){
        root.querySelectorAll('[data-nc-opt]').forEach(function(n){ n.classList.remove('nc-sel'); });
        o.classList.add('nc-sel');
        chooseOption(o.getAttribute('data-nc-opt') === 'upgrade');
      });
    });

    if(els.freemsg && els.charNow){
      els.freemsg.addEventListener('input', function(){ els.charNow.textContent = els.freemsg.value.length; });
    }

    // optional in-theme preview toggle (hidden on live unless present)
    root.querySelectorAll('[data-nc-vibe]').forEach(function(b){
      b.addEventListener('click', function(){
        root.querySelectorAll('[data-nc-vibe]').forEach(function(n){ n.classList.remove('on'); });
        b.classList.add('on');
        setVibe(b.getAttribute('data-nc-vibe'));
        recompute();
      });
    });

    function boot(){ recompute(); }
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(boot); }
    boot();
    setTimeout(boot, 500);
    window.addEventListener('resize', function(){
      clearTimeout(window.__ncrz); window.__ncrz = setTimeout(renderPreview, 150);
    });
  }

  // ===== embeddable mount API (used by the Breakup Workshop card bench) =====
  function renderInto(canvas){
    if(!canvas) return;
    var ctx = canvas.getContext('2d');
    var dim = LAYOUTDIM[state.aspect];
    var rect = canvas.parentNode.getBoundingClientRect();
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var cssW = Math.max(280, rect.width), cssH = cssW * (dim.h / dim.w);
    canvas.width = Math.round(cssW * dpr);
    canvas.height = Math.round(cssH * dpr);
    draw(ctx, canvas.width, canvas.height);
  }

  function mount(opts){
    opts = opts || {};
    var canvas = opts.canvas;
    if(!canvas) return null;
    setVibe(opts.vibe || 'sweet');
    if(opts.name != null) state.name = String(opts.name);
    function rerender(){ computeLayout(); renderInto(canvas); }
    function boot(){ rerender(); }
    if(document.fonts && document.fonts.ready){ document.fonts.ready.then(boot); }
    boot();
    setTimeout(boot, 500);
    if(opts.autoResize !== false){
      window.addEventListener('resize', function(){
        clearTimeout(window.__ncmrz); window.__ncmrz = setTimeout(function(){ renderInto(canvas); }, 150);
      });
    }
    return {
      setName: function(n){ state.name = String(n == null ? '' : n); rerender(); },
      setVibe: function(v){ setVibe(v); rerender(); },
      reshuffle: function(){ state.seed = (state.seed * 1103515245 + 12345) >>> 0 || 1; rerender(); },
      render: rerender
    };
  }

  window.RSNameCard = { init: init, mount: mount };
})();